import { render, staticRenderFns } from "./PLayout.vue?vue&type=template&id=44422176&scoped=true&lang=pug"
import script from "./PLayout.vue?vue&type=script&lang=ts"
export * from "./PLayout.vue?vue&type=script&lang=ts"
import style0 from "./PLayout.vue?vue&type=style&index=0&id=44422176&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44422176",
  null
  
)

export default component.exports